// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld-base';
import L from 'leaflet';

myw.ZoomLevelControlPlugin = myw.Plugin.extend({
    options: {
        enabled: true
    },

    // Actions to be used by map context menu
    actions: {
        toggle: {
            action: 'toggle',
            checked: 'control'
        }
    },

    /**
     * Creates the leaflet control and adds it to the application's map.
     * Options are passed on to the Leaflet control
     * @class   Plugin that adds a control to the map which displays the zoom level of the map
     * @param  {Application}                owner       The application
     * @param  {mousePositionControlOptions}    options
     * @constructs
     * @extends {Plugin}
     */
    initialize(owner, options) {
        myw.Plugin.prototype.initialize.call(this, owner, options);

        if (this.options.enabled) this.enable();
    },

    enable() {
        this.control = new myw.ZoomLevelControl(this.options);
        this.app.map.addControl(this.control);
    },

    toggle() {
        if (this.control) {
            this.app.map.removeControl(this.control);
            this.control = null;
        } else {
            this.enable();
        }
    },

    /**
     * Returns object with current state details <br/>
     * @return {object}
     * @param {boolean} state.minimized Whether the minimap is minimized or not
     */
    getState() {
        return {
            enabled: !!this.control
        };
    }
});

/**
 * Map control plugin to display the zoom level
 *
 */
myw.ZoomLevelControl = L.Control.extend({
    options: {
        position: 'topleft'
    },

    onAdd(map) {
        this._map = map;
        this._container = L.DomUtil.create('div', 'leaflet-bar-part leaflet-bar');
        L.DomUtil.create('a', 'leaflet-control-zoom-display', this._container);
        this.updateMapZoom(map.getZoom());
        map.on('zoomend', this.onMapZoomEnd, this);

        return this._container;
    },

    onRemove(map) {
        map.off('zoomend', this.onMapZoomEnd, this);
    },

    onMapZoomEnd() {
        this.updateMapZoom(this._map.getZoom());
    },

    updateMapZoom(zoom) {
        if (typeof zoom === 'undefined') {
            zoom = '';
        }
        this._container.childNodes[0].innerHTML = zoom;
    }
});

export default myw.ZoomLevelControlPlugin;
